import Box from '@material-ui/core/Box';
import Tab from '@material-ui/core/Tab';
import 'react-quill/dist/quill.snow.css';
import { TextField } from '@mui/material';
import Tabs from '@material-ui/core/Tabs';
import 'react-quill/dist/quill.bubble.css';
import AppBar from '@material-ui/core/AppBar';
import React, { useState, useEffect } from 'react';
import { CircularProgress } from "@material-ui/core";
import Typography from '@material-ui/core/Typography';
import { useDispatch, useSelector } from 'react-redux';
import 'react-accessible-accordion/dist/fancy-example.css';
import { useLocation, useHistory, Link } from 'react-router-dom';

import Overview from './Overview.js';
import constants from '../../constants.js';
import AllActivities from './AllActivities.js';
import RelationsModal from './RelationsModal.js';
import LeftSidebar from './LeftSlidebar/index.js';
import { getProperties } from '../../store/Objects/index.js';
import Activities from '../../components/Activities/index.js';
import { setActiveActivityBox } from '../../store/Activities/index.js';
import LoadingAnimation from '../../components/Animations/LoadingAnimation.js';
import { getSinglePageData, clearSinglePageData, setLoading } from '../../store/SinglePage/index.js';
import socket from '../../socket.js';

const SinglePage = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const { currentWorkspace } = useSelector(state => state['Settings']);
  const { activeActivityBox } = useSelector(state => state['Activities']);
  const { singlePageData, object, isLoading } = useSelector(state => state['SinglePage']);

  const icons = constants['singlePageIcons'];
  let [dropdowns, setDropdowns] = useState({});
  let [singleId, setSingleId] = useState(null);
  let [searchText, setSearchText] = useState('');
  let [selectedTab, setSelectedTab] = useState('overview');
  let [singleActivityId, setSingleActivityId] = useState(null);
  let [relationsModalConfig, setRelationsModalConfig] = useState({ isOpen: false, objectType: 'contact' });
  const setRelationsModal = (isOpen, objectType = 'contact') => setRelationsModalConfig({ isOpen, objectType });

  useEffect(() => { dispatch(getProperties()) }, []);

  // Real-time: refresh activity feed when an incoming email is detected for this contact
  useEffect(() => {
    const handleInboundEmail = (data) => {
      if (!singleId) return;
      const contactIds = data?.contactIds || [];
      const dealIds = data?.dealIds || [];
      const companyIds = data?.companyIds || [];
      const allIds = [...contactIds, ...dealIds, ...companyIds];
      if (allIds.includes(singleId)) {
        const objectType = getObjectType();
        dispatch(getSinglePageData({ objectType, id: singleId }));
      }
    };
    socket.on('activity:email:inbound', handleInboundEmail);
    return () => socket.off('activity:email:inbound', handleInboundEmail);
  }, [singleId]);

  const handleEmailClick = () => {
    // Determine object type from URL
    const objectType = getObjectType();

    if (objectType === 'contacts') {
      // We're on a contact page - use this contact directly
      dispatch(setActiveActivityBox({
        activityBox: 'email',
        associations: { contacts: [singlePageData?.['_id']] },
        selectedContactEmail: singlePageData?.['email']
      }));
    } else if (objectType === 'deals') {
      // We're on a deal page - always open email modal directly
      // The contact selection will be handled within the SendEmail component
      dispatch(setActiveActivityBox({
        activityBox: 'email',
        associations: { deals: [singlePageData?.['_id']] },
      }))
    } else if (objectType === 'companies') {
      // We're on a company page - open email modal
      // The contact selection will be handled within the SendEmail component
      dispatch(setActiveActivityBox({
        activityBox: 'email',
        associations: { companies: [singlePageData?.['_id']] },
      }))
    }
  }

  // Parse URL parameters
  const searchParams = new URLSearchParams(location.search);

  const activityId = searchParams.get('activityId');
  // Initialize activityId from URL parameter
  useEffect(() => { if (activityId) setSingleActivityId(activityId) }, [activityId]);

  const tabFromUrl = searchParams.get('tab');
  // Initialize selectedTab from URL parameter
  useEffect(() => {
    const validTabs = ['overview', 'all', 'task', 'note', 'call', 'email', 'meeting', 'sms', 'whatsapp'];
    if (tabFromUrl && validTabs.includes(tabFromUrl)) setSelectedTab(tabFromUrl);
  }, [tabFromUrl]);

  // Fetch data when component mounts or route changes
  useEffect(() => {
    const currentId = props['match']['params']['id'];
    // Always fetch data when the ID changes
    if (currentId) fetchData();
  }, [props['match']['params']['id'], location['pathname']]);

  const toggleDropdownAction = (id) => setDropdowns((prev) => ({ ...prev, [id]: !prev[id] }));

  // Update URL with new tab parameter
  const updateTabInUrl = (newTab) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('tab', newTab);
    history.push({ pathname: location['pathname'], search: searchParams.toString() });
  }

  const getObjectType = () => {
    const pathParts = location.pathname.split('/');
    // Check if first part is a workspace ID (24-char hex string)
    const hasWorkspaceId = pathParts[1] && pathParts[1].match(/^[a-fA-F0-9]{24}$/);
    return hasWorkspaceId ? pathParts[2] : pathParts[1];
  }

  const fetchData = async () => {
    const objectType = getObjectType();
    const newSingleId = props['match']['params']['id'];
    setSingleId(newSingleId);
    dispatch(setLoading(true));
    dispatch(clearSinglePageData());
    dispatch(getSinglePageData({ objectType, id: newSingleId }));
  }

  return (
    <div className="single-deal-page">
      {isLoading ? <div style={{ padding: '40px', textAlign: 'center', display: 'flex', justifyContent: 'center', margin: '0 auto' }}> <LoadingAnimation /> </div> :
        <div className='single-deal-inner accordian-tabs-area'>
          <div className='left-side'>
            {/* Sidebar */}
            <LeftSidebar singlePageData={singlePageData} singleId={singleId} dropdowns={dropdowns} toggleDropdownAction={toggleDropdownAction} setRelationsModal={setRelationsModal} />
          </div>
          {/* Main Content */}
          <main className={`deal-main-content ${activeActivityBox ? 'right-sidebar-active' : ''}`}>
            <div className="deal-main-content-header">
              <div className="deal-main-content-header-left">
                <div className='searchbox'>
                  <i className='icon'>
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_224_579)">
                        <path d="M17.8568 16.2345L13.203 11.5807C14.0782 10.377 14.5958 8.8965 14.5958 7.2975C14.5958 3.27375 11.322 0 7.2975 0C3.27375 0 0 3.27375 0 7.2975C0 11.322 3.27375 14.595 7.2975 14.595C8.823 14.595 10.2397 14.1247 11.4128 13.3215L16.0912 18L17.8568 16.2345ZM2.1405 7.2975C2.1405 4.4535 4.45425 2.13975 7.29825 2.13975C10.1423 2.13975 12.456 4.4535 12.456 7.2975C12.456 10.1415 10.1423 12.4552 7.29825 12.4552C4.4535 12.4552 2.1405 10.1415 2.1405 7.2975Z" fill="#89868D" />
                      </g>
                      <defs> <clipPath id="clip0_224_579"> <rect width="18" height="18" fill="white" /> </clipPath> </defs>
                    </svg>
                  </i>
                  <TextField
                    fullWidth
                    hiddenLabel
                    size="small"
                    variant="standard"
                    value={searchText}
                    placeholder="Search activities"
                    onChange={(e) => setSearchText(e['target']['value'])}
                  />
                </div>
              </div>
            </div>
            <div className="deal-activities">
              {singleActivityId
                ? <Link to={currentWorkspace?._id ? `/${currentWorkspace._id}/${getObjectType()}/${singleId}?tab=all` : `/${getObjectType()}/${singleId}?tab=all`} className='back-timeline mb-3' onClick={() => setSingleActivityId(null)}>
                  <i className='icon mr-1'>
                    <svg width="5" height="7" viewBox="0 0 5 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.23859 6.40987C4.23859 6.25987 4.18332 6.10987 4.0649 5.99145L1.6965 3.62305L4.0649 1.25464C4.29385 1.02569 4.29385 0.646749 4.0649 0.417803C3.83596 0.188857 3.45701 0.188857 3.22807 0.417803L0.441241 3.20463C0.212295 3.43357 0.212295 3.81252 0.441241 4.04147L3.22807 6.82829C3.45701 7.05724 3.83596 7.05724 4.0649 6.82829C4.18332 6.70987 4.23859 6.55987 4.23859 6.40987Z" fill="currentColor"></path></svg>
                  </i>
                  Back to activities
                </Link>
                : <AppBar position="static">
                  <Tabs value={selectedTab} onChange={(event, newValue) => { setSelectedTab(newValue), updateTabInUrl(newValue) }} aria-label="simple tabs example">
                    <Tab icon={icons['overview']} label="Overview" value='overview' />
                    <Tab icon={icons['all-activities']} label="All Activities" value='all' />
                    <Tab icon={icons['task']} label="Task" value='task' />
                    <Tab icon={icons['notes']} label="Note" value='note' />
                    <Tab icon={icons['calls']} label="Call" value='call' />
                    <Tab icon={icons['emails']} label="Email" value='email' />
                    <Tab icon={icons['meetings']} label="Meeting" value='meeting' />
                    <Tab icon={icons['sms']} label="SMS" value='sms' />
                    <Tab icon={icons['whatsapp']} label="WhatsApp" value='whatsapp' />
                  </Tabs>
                </AppBar>}
              <div className={`tabs-content tab-single-page`}>
                {selectedTab == 'overview' && <Overview singleActivityId={singleActivityId} singleId={singleId} singlePageData={singlePageData} dropdowns={dropdowns} setDropdowns={setDropdowns} toggleDropdownAction={toggleDropdownAction} searchText={searchText} objectType={location.pathname.split('/')[1]} />}
                {['all', 'email', 'note', 'call', 'task', 'meeting', 'sms', 'whatsapp'].includes(selectedTab) && <AllActivities singleActivityId={singleActivityId} singleId={singleId} selectedTab={selectedTab} singlePageData={singlePageData} dropdowns={dropdowns} setDropdowns={setDropdowns} toggleDropdownAction={toggleDropdownAction} searchText={searchText} handleEmailClick={handleEmailClick} />}
              </div>
            </div>
          </main>
          {/* Activities Sidebar - handles all activity types (Note, Task, Email, SMS, WhatsApp, Meeting) */}
          <Activities />
          {relationsModalConfig['isOpen'] &&
            <div className='left-side right-side-style add-company-style show'>
              {/* Relation Modal */}
              <RelationsModal
                singlePageData={singlePageData}
                setRelationsModal={setRelationsModal}
                objectType={relationsModalConfig['objectType']}
                sourceObject={{ id: singleId, type: object['name'] }} // Remove 's' from 'deals', 'contacts', etc.
              />
            </div>
          }
        </div>
      }
    </div>
  )
}

export default SinglePage